var indicative = require("indicative");

var specialistsUtils = (function() {

    var is_valid_postalcode = function(data, field, message, args) {
        return new Promise(function(resolve, reject) {
            if (/^\d{5}$/.test(data[field])) {
                return resolve('is valid postal code');
            } else {
                return reject(message);
            }
        });
    };

    var _validate = function(postalCode) {
        var Indicative = new indicative();
        Indicative.extend('postalcode', 'Postal code need be a 5-digits number', is_valid_postalcode);

        var rules = {
            postalCode: 'required|postalcode'
        };

        var messages = {
            "postalCode.required": "Postal code is required",
            "postalCode.postalcode": "Postal code need be a 5-digits number"
        };

        var data = {
            postalCode: postalCode
        };

        return Indicative
            .validateAll(rules, data, messages)
            .then(function(validation_passed) {
                return true;
            })
            .catch(function(error) {
                var errorMessage = '';
                for (var i = 0, errorLength = error.length; i < errorLength; i++) {
                    errorMessage += error[i].message + '\n';
                };
                return errorMessage;
            });
    };

    return {
        validate: _validate
    };

})();

module.exports = specialistsUtils;



// WEBPACK FOOTER //
// ./src/common/modules/specialists/specialistsUtils.js